<template>
  <div class="entry-list-page">
    <van-tabs
      v-if="matchGroups.length"
      v-model="activeMatchId"
      class="group-tabs"
      scrollable
      :border="false"
      title-active-color="#303133"
      title-inactive-color="#909399"
      color="#337ECC"
      line-width="28px"
      line-height="3px"
      @change="onGroupTabChange"
    >
      <van-tab
        v-for="m in matchGroups"
        :key="m.id"
        :title="tabTitle(m)"
        :name="String(m.id)"
      />
    </van-tabs>

    <div class="list-container">
      <div v-if="listLoading" class="state-tip">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
      <template v-else-if="matchGroups.length === 0">
        <div class="state-tip">
          <van-empty description="暂无赛事组别" />
        </div>
      </template>
      <template v-else>
        <div v-if="teams.length" class="entry-cards">
          <div
            v-for="row in teams"
            :key="row.id"
            class="entry-card"
            :class="{ 'entry-card--clickable': showEntryRoster }"
            role="button"
            tabindex="0"
            @click="onEntryCardClick(row)"
            @keyup.enter="onEntryCardClick(row)"
          >
            <img
              v-if="badgeUrl(row.badge || matchIcon)"
              class="entry-card__badge"
              :src="badgeUrl(row.badge || matchIcon)"
              alt=""
            >
            <div class="entry-card__main">
              <span class="entry-card__name">{{ row.name || '—' }}</span>
            </div>
            <div v-if="showEntryRoster" class="entry-card__roster">
              <div class="entry-card__roster-label">参赛名单</div>
              <div class="entry-card__roster-num">{{ rosterCountText(row.playerCount) }}</div>
            </div>
          </div>
        </div>
        <div v-else class="state-tip">
          <van-empty description="暂无参赛队伍" />
        </div>
        <p class="list-note">参赛数据由组委会提供</p>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Loading, Empty } from 'vant'
Vue.use(Tabs).use(Tab).use(Loading).use(Empty)
import { getBMMatchList2, getBMMatchSignupTeamList,getBMUnionMatch } from '@/api/match'
import { QNImageUtil } from '@/utils'

export default {
  data() {
    return {
      unionMatchId: '',
      matchGroups: [],
      activeMatchId: '',
      teams: [],
      listLoading: false,
      matchIcon: ''
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.loadGroupTabs()
    this.getBMUnionMatch()
  },
  computed: {
    /** 当前选中的赛事组别（tabs） */
    activeGroup() {
      const id = String(this.activeMatchId)
      return (this.matchGroups || []).find(m => String(m.id) === id) || null
    },
    /** unitType：0 队伍 1 个人 2 组合 — 仅队伍展示「参赛名单」人数 */
    showEntryRoster() {
      const g = this.activeGroup
      if (!g) return false
      const u = Number(g.unitType)
      return u === 0
    }
  },
  methods: {
    getBMUnionMatch() {
      if (!this.unionMatchId) return
      getBMUnionMatch({ unionMatchId: this.unionMatchId }).then(res => {
        if (res) {
          this.matchIcon = res.data.match.icon
        }
      })
    },
    tabTitle(m) {
      return (m && (m.group || m.matchGroup || m.name)) || '组别'
    },
    badgeUrl(badge) {
      const s = badge && String(badge).trim()
      if (!s) return ''
      return QNImageUtil.imageView(s, 88, 88)
    },
    rosterCountText(n) {
      if (n === '' || n === null || n === undefined) return '—'
      const x = Number(n)
      return Number.isNaN(x) ? String(n) : String(x)
    },
    loadGroupTabs() {
      if (!this.unionMatchId) return
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then(res => {
        if (res === false) {
          this.matchGroups = []
          return
        }
        const list = (res && res.data && res.data.list) || []
        this.matchGroups = list
        if (list.length) {
          this.activeMatchId = String(list[0].id)
          this.fetchSignupList()
        } else {
          this.activeMatchId = ''
          this.teams = []
        }
      }).catch(() => {
        this.matchGroups = []
        this.teams = []
      })
    },
    onGroupTabChange(name) {
      this.activeMatchId = name
      this.fetchSignupList()
    },
    /** 仅队伍类型进入球员名单详情（与 attend-match-player 同源 getBMPlayerList） */
    onEntryCardClick(row) {
      if (!this.showEntryRoster || !row || row.id == null) return
      this.$router.push({
        path: `/match-detail/${this.unionMatchId}/entry-team-roster`,
        query: {
          matchId: String(this.activeMatchId),
          teamId: String(row.id),
        },
      })
    },
    fetchSignupList() {
      const matchId = this.activeMatchId
      if (!matchId) {
        this.teams = []
        return
      }
      this.listLoading = true
      getBMMatchSignupTeamList({ matchId })
        .then(res => {
          if (res === false) {
            this.teams = []
            return
          }
          const list = (res && res.data && res.data.list) || []
          const sorted = list.slice().sort((a, b) => {
            const ga = Number(a.groupIndex)
            const gb = Number(b.groupIndex)
            const ha = Number.isNaN(ga) ? 0 : ga
            const hb = Number.isNaN(gb) ? 0 : gb
            if (ha !== hb) return ha - hb
            return String(a.name || '').localeCompare(String(b.name || ''), 'zh')
          })
          this.teams = sorted
        })
        .catch(() => {
          this.teams = []
        })
        .finally(() => {
          this.listLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.entry-list-page {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.list-container {
  padding: 12px 16px 24px;
}

.state-tip {
  padding: 48px 16px 24px;
  text-align: center;
}

.entry-cards {
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: 12px;
  }
}

.entry-card {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 10px;
  padding: 12px 14px;
  box-sizing: border-box;
}

.entry-card--clickable {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.entry-card--clickable:active {
  opacity: 0.92;
}

.entry-card__badge {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 12px;
  background: #f0f2f5;
}

.entry-card__main {
  flex: 1;
  min-width: 0;
}

.entry-card__name {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entry-card__roster {
  flex-shrink: 0;
  margin-left: 12px;
  text-align: right;
}

.entry-card__roster-label {
  font-size: 12px;
  color: #303133;
  line-height: 16px;
}

.entry-card__roster-num {
  margin-top: 2px;
  font-size: 16px;
  font-weight: 500;
  color: #FF682C;
  line-height: 24px;
}

.list-note {
  margin: 16px 0 0;
  font-size: 13px;
  color: #b5b5b5;
  text-align: center;
}
</style>

<style lang="scss">
.entry-list-page {
  .group-tabs {
    .van-tabs__nav {
      background: #fff;
    }
    .van-tab {
      font-size: 14px;
      padding: 0 14px;
      flex: 0 0 auto;
    }
    .van-tabs__line {
      border-radius: 2px;
    }
  }
}
</style>
